import Controller from './controller';

App.Widgets.setWidgetStarterInNamespace('WidgetLoading', Controller);



// WEBPACK FOOTER //
// ./collection-institutional-portal/src/widgets/widget-loading/scripts/index.js